export default __webpack_public_path__ + "static/media/birthday.b0cd2f03.svg";